import * as RadixDialog from '@radix-ui/react-dialog';
import { Content } from './overrides';
import { StyledPanel, StyledTitle } from './dialog.styled';

export const Dialog = {
  ...RadixDialog,
  Overlay: undefined,
  Content,
  Title: StyledTitle,
  Panel: StyledPanel,
};
